<template>
    <!-- <div class="User padding-20 bgc box-shadow"> -->
    <div class="User">
        <div class="nav_box box-shadow">
            <el-menu :default-active='activeIndex' mode="horizontal" class="el-menu-demo">
                <el-menu-item index="1" @click="profileData">数据概况</el-menu-item>
                <el-menu-item index="2" @click="traffic">流量分析</el-menu-item>
                <el-menu-item index="3" @click="trading">交易分析</el-menu-item>
                <el-menu-item index="4" @click="content">内容分析</el-menu-item>
                <el-menu-item index="5" @click="user">用户分析</el-menu-item>
            </el-menu>
        </div>
        <div class="select_box">
            <div style="width: 100px;">
                <el-select v-model="dateOptionValue" placeholder="自然天">
                    <el-option v-for="item in dataOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div v-show="dateOptionValue === 1">
                <el-date-picker :clearable="false" v-model="dateValue" align="left" type="date" :placeholder="getDateTime(0)" :picker-options="pickerOptions1"></el-date-picker>
            </div>
            <div v-show="dateOptionValue === 2">
                <el-date-picker :picker-options="disabledDatePickerOptions" :clearable="false" v-model="dateValue" align="left" type="week" format="yyyy 第 WW 周" placeholder="选择周"></el-date-picker>
            </div>
            <div v-show="dateOptionValue === 3">
                <el-date-picker :picker-options="disabledDatePickerOptions" :clearable="false" v-model="dateValue" align="left" type="month" placeholder="选择月"></el-date-picker>
            </div>
            <el-button type="primary" @click="userDataSearch" plain>搜索</el-button>
        </div>
        <div class="user_container1 padding-20 bgc box-shadow">
            <div class="title_box">
                <p>用户概況及趋势</p>
                <p @click="userExport"><img :src="icon" alt="">导出</p>
            </div>
            <div class="access_box">
                <div class="access_item" v-for="(item, index) of accessData" :key="index">
                    <p>
                        <span>{{item.title}}</span>
                        <el-tooltip placement="top">
                            <div class="tooltip_content" slot="content">{{item.toolText}}</div>
                            <img class="tooltip_icon" :src="item.icon" alt="">
                        </el-tooltip>
                    </p>
                    <p>{{item.access}}</p>
                    <p>较前一天 {{item.rate}}</p>
                </div>
            </div>
            <div class="echarts_line_box1">
                <UserEchartsLine1 :echartsLineData="echartsLineData"></UserEchartsLine1>
            </div>
        </div>
        <!-- <div class="user_container2 padding-20 bgc box-shadow">
            <div class="title_box">
                <p>付费用户</p>
                <p><img :src="icon" alt="">导出</p>
            </div>
            <div class="table_box">
                <table>
                    <tr>
                        <th>客户类型</th>
                        <th>
                            <p>
                                <span>用户数</span>
                                <el-tooltip placement="top">
                                    <div class="tooltip_content" slot="content">新付费用户-用户数：筛选时间之前没有在店铺付过费，在筛选时间内在店铺首次付款的用户数量<br />老付费用户-用户数：筛选时间内，在店铺内有付款，且首次付款是在筛选时间之前的用户数 （拼团在成团时计入筛选，问答在回答后计入筛选，API导入订单不计入筛选）</div>
                                    <img class="tooltip_icon" :src="toolIcon" alt="">
                                </el-tooltip>
                            </p>
                        </th>
                        <th>
                            <p>
                                <span>用户数占比</span>
                                <el-tooltip placement="top">
                                    <div class="tooltip_content" slot="content">新付费用户-用户数占比：筛选时间内，新付费用户数 / 全部付费用户数<br />老付费用户-用户数占比：筛选时间内，老付费用户数 / 全部付费用户数</div>
                                    <img class="tooltip_icon" :src="toolIcon" alt="">
                                </el-tooltip>
                            </p>
                        </th>
                        <th>
                            <p>
                                <span>客单价</span>
                                <el-tooltip placement="top">
                                    <div class="tooltip_content" slot="content">全部付费用户-客单价：筛选时间内，全部付费用户的付款金额/用户数<br />新付费用户-客单价：筛选时间内，新付费用户的付款金额/新付费用户数<br />老付费用户-客单价：筛选时间内，老付费用户的付款金额/老付费用户数</div>
                                    <img class="tooltip_icon" :src="toolIcon" alt="">
                                </el-tooltip>
                            </p>
                        </th>
                        <th>
                            <p>
                                <span>付款金额(元)</span>
                                <el-tooltip placement="top">
                                    <div class="tooltip_content" slot="content">全部付费用户-付款金额(元)：筛选时间内，全部付费用户的付款金额之和<br />新付费用户-付款金额(元)：筛选时间内，新付费用户的付款金额之和<br />老付费用户-付款金额(元)：筛选时间内，老付费用户成功付款订单的金额之和 （拼团在成团时计入筛选，问答在回答后计入筛选，API导入订单不计入筛选）</div>
                                    <img class="tooltip_icon" :src="toolIcon" alt="">
                                </el-tooltip>
                            </p>
                        </th>
                        <th>
                            <p>
                                <span>付款转化率</span>
                                <el-tooltip placement="top">
                                    <div class="tooltip_content" slot="content">全部付费用户-访问-付款转化率：筛选时间内，全部付费用户数/店铺访客数<br />新付费用户-访问-付款转化率：筛选时间内，新付费用户数/店铺访客数中无购买记录的访客数<br />老付费用户-访问-付款转化率：筛选时间内，老付费用户数/访问过店铺的付费用户数</div>
                                    <img class="tooltip_icon" :src="toolIcon" alt="">
                                </el-tooltip>
                            </p>
                        </th>
                    </tr>
                    <tr v-for="(item, index) in tableData" :key="index">
                        <td>{{item.type}}</td>
                        <td>0&emsp;--</td>
                        <td>100%</td>
                        <td>--&emsp;--</td>
                        <td>0.00&emsp;--</td>
                        <td>--&emsp;--</td>
                    </tr>
                </table>
            </div>
            <div class="echarts_line2_box">
                <div class="radio_box">
                    <el-radio v-model="radio" label="1">用户数</el-radio>
                    <el-radio v-model="radio" label="2">客单价</el-radio>
                    <el-radio v-model="radio" label="3">付款金额</el-radio>
                    <el-radio v-model="radio" label="4">访问-付款转化率</el-radio>
                </div>
                <div class="echarts_warp">
                    <UserEchartsLine2></UserEchartsLine2>
                </div>
            </div>
            <div class="echarts_line3_box">
                <UserEchartsLine3></UserEchartsLine3>
            </div>
        </div> -->
    </div>
</template>

<script>
import UserEchartsLine1 from 'views/dataCenter/dataTabs/echarts/UserEchartsLine1'
// import UserEchartsLine2 from 'views/dataCenter/dataTabs/echarts/UserEchartsLine2'
// import UserEchartsLine3 from 'views/dataCenter/dataTabs/echarts/UserEchartsLine3'
import {getUserData, getUserProfileExport} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'User',
    data() {
        return {
            activeIndex: '5',
            icon: require('@/common/images/other/data_center_report_icon@2x.png'),
            toolIcon: require('@/common/images/other/data_center_tools_icon@2x.png'),
            tableData: [
                {
                    type: '全部成交用户'
                },
                {
                    type: '新付费用户'
                },
                {
                    type: '老付费用户'
                }
            ],
            accessData: [
                {title: '新增用户', icon: require('@/common/images/other/data_center_tools_icon@2x.png'), toolText: '筛选时间内，第一次访问店铺的用户数', access: 0, rate: '0.00%'},
                {title: '活跃用户', icon: require('@/common/images/other/data_center_tools_icon@2x.png'), toolText: '筛选时间内， 访问过店铺的用户数', access: 0, rate: '0.00%'},
                {title: '累计用户', icon: require('@/common/images/other/data_center_tools_icon@2x.png'), toolText: '截至到筛选时间，访问过店铺的全部用户数', access: 0, rate: '0.00%'},
                {title: '付费用户', icon: require('@/common/images/other/data_center_tools_icon@2x.png'), toolText: '筛选时间内，付款成功的用户数，一人多次付款记为一人（拼团在成团时计入筛选，问答在回答后计入筛选，API导入订单不计入筛选）', access: 0, rate: '0.00%'},
                {title: '累计付费用户', icon: require('@/common/images/other/data_center_tools_icon@2x.png'), toolText: '累计付费用户：截至到筛选时间，店铺内所有付款成功的用户数（拼团在成团时计入筛选，问答在回答后计入筛选，API导入订单不计入筛选）', access: 0, rate: '0.00%'}
            ],
            echartsLineData: [],
            dataOptions: [
                {
                    value: 1,
                    label: '自然天'
                },
                {
                    value: 2,
                    label: '自然周'
                },
                {
                    value: 3,
                    label: '自然月'
                }
            ],
            dateOptionValue: 1,
            // dateValue: this.getDateTime(0),
            dateValue: '',
            pickerOptions1: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 24 * 60 * 60 * 1000
                },
                shortcuts: [
                    {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date()
                            date.setTime(date.getTime() - 3600 * 1000 * 24)
                            picker.$emit('pick', date)
                        }
                    },
                    {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date()
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', date)
                        }
                    }
                ]
            },
            disabledDatePickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 24 * 60 * 60 * 1000
                }
            },
            radio: '1'
        }
    },
    mounted() {
        this.findUserData(1, this.getDateTime(0))
    },
    methods: {
        profileData() {
            this.$router.push({name: 'ProfileData'})
        },
        traffic() {
            this.$router.push({name: 'Traffic'})
        },
        trading() {
            this.$router.push({name: 'Trading'})
        },
        content() {
            this.$router.push({name: 'Content'})
        },
        user() {
            this.$router.push({name: 'User'})
        },
        // 用户概况及趋势导出
        userExport() {
            if (this.dateOptionValue === '自然天' || this.dateOptionValue === 1 || this.dateOptionValue === 2 || this.dateOptionValue === 3) {
                if (this.dateValue === '') {
                    this.$message.error(`请选择导出日期！`)
                    return
                }
            }
            if (this.dateOptionValue === 4) {
                if (this.periodTime === '') {
                    this.$message.error(`请选择导出日期！`)
                    return
                }
            }
            this.setLoading(true)
            var params = {}
            if (this.dateOptionValue === 1) {
                params = {
                    beginTime: this.transferDate(this.dateValue),
                    endTime: this.transferDate(this.dateValue)
                }
            } else if (this.dateOptionValue === 2) {
                params = {
                    beginTime: this.getWeek(this.dateValue)[0],
                    endTime: this.getWeek(this.dateValue)[1]
                }
            } else if (this.dateOptionValue === 3) {
                params = {
                    beginTime: this.getMonth(this.dateValue)[0],
                    endTime: this.getMonth(this.dateValue)[1]
                }
            }
            getUserProfileExport({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.exportTips = false
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '用户概况及趋势' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 用户概况及趋势搜索
        userDataSearch() {
            if (this.dateValue === '') {
                this.$message.error(`请选择搜索日期！`)
                return
            }
            // this.dateOptionValue = this.dateOptionValue === '自然天' ? 1 : this.dateOptionValue
            this.findUserData(this.dateOptionValue, this.transferDate(this.dateValue))
        },
        // 用户概况及趋势初始数据
        findUserData(type, time) {
            this.setLoading(true)
            var params = {
                timeFormat: type,
                beginTime: time
            }
            getUserData({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.echartsLineData = data.data
                    this.accessData[0].access = data.data.newUsers
                    this.accessData[0].rate = data.data.newUsersgrowthrate
                    this.accessData[1].access = data.data.activeUsers
                    this.accessData[1].rate = data.data.activeusersgrowthrate
                    this.accessData[2].access = data.data.cumulativeUsers
                    this.accessData[2].rate = data.data.cumulativeusersgrowthrate
                    this.accessData[3].access = data.data.orderpaycustomer
                    this.accessData[3].rate = data.data.orderpaycustomergrowthrate
                    this.accessData[4].access = data.data.cumulativepayusers
                    this.accessData[4].rate = data.data.cumulativepayusersweekthan
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取昨日 日期
        getDateTime(type) {
            // type :  1--今天日期  0--昨天日期
            var time = null
            if (type === 1) {
                time = (new Date()).getTime()
            } else if (type === 0) {
                time = (new Date()).getTime() - 24 * 60 * 60 * 1000
            }
            var dateTime = new Date(time) // 获取的是前一天日期
            var year = dateTime.getFullYear()
            var month = dateTime.getMonth() + 1
            month = month < 10 ? '0' + month : month
            var day = dateTime.getDate()
            day = day < 10 ? '0' + day : day
            dateTime = year + '-' + month + '-' + day
            return dateTime
        },
        getWeek(value) {
            // 按周日为一周的最后一天计算
            var date = value
            // 今天是这周的第几天
            var today = date.getDay()
            // 上周日距离今天的天数（负数表示）
            var stepSunDay = -today + 1
            // 如果今天是周日
            if (today === 0) {
                stepSunDay = -7
            }
            // 周一距离今天的天数（负数表示）
            var stepMonday = 7 - today
            var time = date.getTime()
            var monday = new Date(time + stepSunDay * 24 * 3600 * 1000)
            var sunday = new Date(time + stepMonday * 24 * 3600 * 1000)
            // 本周一的日期 （起始日期）
            var startDate = this.transferDate(monday) // 日期变换
            // 本周日的日期 （结束日期）
            var endDate = this.transferDate(sunday) // 日期变换
            return [startDate, endDate]
        },
        getMonth(value) {
            // 获取当前月的第一天
            var start = value
            start.setDate(1)
            // 获取当前月的最后一天
            var date = value
            var currentMonth = date.getMonth()
            var nextMonth = ++currentMonth
            var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
            var oneDay = 1000 * 60 * 60 * 24
            var end = new Date(nextMonthFirstDay - oneDay)
            var startDate = this.transferDate(start) // 日期变换
            var endDate = this.transferDate(end) // 日期变换
            return [startDate, endDate]
        },
        transferDate(date) {
            // 年
            var year = date.getFullYear()
            // 月
            var month = date.getMonth() + 1
            // 日
            var day = date.getDate()
            if (month >= 1 && month <= 9) {
                month = '0' + month
            }
            if (day >= 0 && day <= 9) {
                day = '0' + day
            }
            var dateString = year + '-' + month + '-' + day
            return dateString
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        UserEchartsLine1
        // UserEchartsLine2,
        // UserEchartsLine3
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.User {
    .select_box{
        margin: 20px 0;
        display: flex;
        justify-content: flex-end;
        &>div {
            margin-right: 20px;
        }
        .el-input__inner {
            height: 36px;
        }
        .el-input__icon {
            line-height: 0;
            height: 36px;
        }
        .el-button {
            height: 36px;
        }
    }
    .title_box{
        height: 50px;
        background-color: #F5F7FA;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px 0 15px;
        margin-bottom: 20px;
        p {
            height:16px;
            line-height:16px;
        }
        &>p:nth-of-type(1) {
            border-left: 2px solid #409EFF;
            padding-left: 10px;
        }
        &>p:nth-of-type(2) {
            color: #409EFF;
            display: flex;
            align-items: center;
            cursor: pointer;
            img{
                width: 16px;
                height: 14px;
                margin-right: 8px;
            }
        }
    }
    .user_container1{
        .access_box{
            display: flex;
            .access_item{
                width: 20%;
                height: 138px;
                box-sizing: border-box;
                padding: 20px;
                color: #606266;
                border: 1px solid #DCDFE6;
                border-right: none;
                p:nth-of-type(1) {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    img{
                        width: 14px;
                        height: 14px;
                        cursor: pointer;
                    }
                }
                p:nth-of-type(2) {
                    font-size:28px;
                    height:40px;
                    line-height:40px;
                    margin: 10px 0;
                }
                p:nth-of-type(3), p:nth-of-type(1) {
                    height: 20px;
                    line-height:20px;
                }
            }
            .access_item:nth-last-of-type(1) {
                border-right: 1px solid #DCDFE6;
            }
        }
        .echarts_line_box1 {
            margin-top: 20px;
            height: 430px;
        }
    }
    .user_container2{
        margin-top: 20px;
        padding-bottom: 100px;
        .table_box {
            table {
                width: 100%;
                border-top: 2px solid #DCDFE6;
                color: #303133;
                tr {
                    width: 100%;
                    height: 60px;
                    padding: 0 20px;
                    border-bottom: 1px solid #DCDFE6;
                    th {
                        width: 16.66%;
                        font-weight: 600;
                        vertical-align: middle;
                        p{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            img{
                                width: 14px;
                                height: 14px;
                                margin-left: 6px;
                                cursor: pointer;
                            }
                        }
                    }
                    th:nth-of-type(1) {
                        text-align: left;
                        padding-left: 20px;
                    }
                    td {
                        width: 16.66%;
                        vertical-align: middle;
                        text-align: center;
                    }
                    td:nth-of-type(1) {
                        text-align: left;
                        padding-left: 20px;
                    }
                }
                tr:nth-of-type(1) {
                    height: 54px;
                    background-color: #FAFAFA;
                }
            }
        }
        .echarts_line2_box{
            margin: 40px 0;
            .radio_box{
                text-align: center;
            }
            .echarts_warp{
                margin-top: 20px;
                height: 420px;
            }
        }
        .echarts_line3_box{
            height: 420px;
        }
    }
}
</style>
<style scoped>
.tooltip_content {
    color: #606266;
    padding: 0 15px;
    line-height: 20px;
    width: 320px;
}
</style>